export default function FilterSidebarSkeleton() {
  return (
    <div className="p-4 space-y-6 animate-pulse">
      {/* Filter section 1 */}
      <div>
        <div className="h-5 bg-gray-200 rounded w-24 mb-3"></div>
        <div className="space-y-2">
          <div className="h-8 bg-gray-200 rounded w-full"></div>
          <div className="h-8 bg-gray-200 rounded w-3/4"></div>
          <div className="h-8 bg-gray-200 rounded w-5/6"></div>
        </div>
      </div>

      {/* Filter section 2 */}
      <div>
        <div className="h-5 bg-gray-200 rounded w-20 mb-3"></div>
        <div className="flex flex-wrap gap-2">
          <div className="h-6 bg-gray-200 rounded-full w-16"></div>
          <div className="h-6 bg-gray-200 rounded-full w-20"></div>
          <div className="h-6 bg-gray-200 rounded-full w-14"></div>
          <div className="h-6 bg-gray-200 rounded-full w-18"></div>
        </div>
      </div>

      {/* Action buttons */}
      <div className="flex gap-2 pt-4">
        <div className="h-8 bg-gray-200 rounded w-16"></div>
        <div className="h-8 bg-gray-200 rounded w-20"></div>
      </div>
    </div>
  );
}
